import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-grievance-link',
  templateUrl: './grievance-link.component.html',
  styleUrls: ['./grievance-link.component.scss']
})
export class GrievanceLinkComponent implements OnInit{
constructor(){}
  ngOnInit(): void {
  
}
}
